module.exports = __webpack_public_path__ + "img/menu-bg.905a50be.png";